import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DepartmentsComponent } from './journey/departments/departments.component';
import { LoginComponent } from './journey/login/login.component';
import { ServicesComponent } from './journey/services/services.component';
import { LocationComponent } from './journey/location/location.component';
import { CalendarComponent } from './journey/calendar/calendar.component';
import { BookingDetailsComponent } from './journey/booking-details/booking-details.component';
import { SummaryComponent } from './journey/summary/summary.component';
import { ConfirmationComponent } from './journey/confirmation/confirmation.component';
import { GuardService } from './services/guards/guard.service';
import { AccountGuardService } from './services/guards/account-guard.service';
import { SessionComponent } from './journey/session/session.component';
import { ThankyouComponent } from './journey/thankyou/thankyou.component';
import { VerifyPaymentComponent } from './journey/verify-payment/verify-payment.component';

const routes: Routes = [
  { path: '', redirectTo: '/departments', pathMatch: 'full' },
  { path: 'departments', component: DepartmentsComponent },
  { path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' } },
  { path: 'services', component: ServicesComponent, data: { breadcrumb: 'Services' } },
  { path: 'locations', component: LocationComponent },
  { path: 'calendar', component: CalendarComponent, data: { breadcrumb: 'Date & Time' } },
  { path: 'booking-details', component: BookingDetailsComponent, data: { breadcrumb: 'Booking Form' } },
  { path: 'summary', component: SummaryComponent, data: { breadcrumb: 'Summary' } },
  { path: 'confirmation', component: ConfirmationComponent, data: { breadcrumb: 'Confirmation' } },
  { path: 'payment-verify', component: VerifyPaymentComponent },
  { path: 'sessionExpired', component: SessionComponent },
  { path: 'thankyou', component: ThankyouComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
